export default "__VITE_ASSET__DK_3emWP__"